export const DOWNLOAD_MOBILE_APP_PAGE_URL = 'https://medentee.com/app-download'
export const PRIVACY_POLICY_URL = 'https://medentee.com/privacy-policy'
export const TERMS_OF_USE_URL = 'https://medentee.com/terms-of-use'
export const KNOWLEDGE_BASE_URL = 'https://docs.medentee.com/medee-help-center'
export const HELP_CENTER_URL = 'https://docs.medentee.com/medee-help-center'
